import Loader from "../../../Loader/Index";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black")} HoverOption *
 * @param {Object} props
 * @param {String} props.btnText - Default string to show
 * @param {BtnType} props.btnType - One of "button" or "submit"
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledTextColor - Color of text when button is enabled (var only)
 * @param {String?} props.disabledTextColor - Color of text when button is disabled (defaults to enabledTextColor) (var only)
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {String?} props.outLineColor - Color of button outline (border color) (var only)
 * @param {boolean} props.isLoaderNeeded - Should loader spin inside button
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {boolean} props.inActiveVariantNeeded - If you want to use inActive variant of button eg:- true or false
 * @returns {JSX.Element}
 */
const PrimaryLargeButton = ({
  btnText,
  btnType,
  handleFunction,
  isDisabled,
  enabledTextColor,
  disabledTextColor,
  enabledBgColor,
  disabledBgColor,
  isLoaderNeeded,
  isLoading,
  outLineColor,
  hoverOption,
  buttonRef,
  inActiveVariantNeeded,
  isFillNeeded = false,
}) => {
  return (
    <button
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex z-z-index-base relative justify-center items-center p-padding-sm ${isFillNeeded ? "Qsmd:max-w-primary-large-btn-width-login" : "max-w-primary-large-btn-width"}  w-full h-auto rounded-border-radius-md cursor-${
        isDisabled
          ? `not-allowed ${inActiveVariantNeeded ? "" : "opacity-light-opacity"} `
          : `pointer  ${
              isLoading
                ? null
                : hoverOption === "white"
                  ? "global-hover-white"
                  : "global-hover-black"
            }`
      }`}
      style={{
        border: outLineColor ? `var(--border) solid ${outLineColor}` : "",
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor.toString()
            : enabledBgColor.toString(),
      }}
    >
      {isLoading && isLoaderNeeded ? (
        <div className="absolute flex w-width-full h-height-full justify-center items-center top-top-base">
          <Loader
            height="var(--icon-md)"
            width="var(--icon-md)"
          />
        </div>
      ) : null}

      <div className="flex flex-row items-center gap-gap-xs">
        <div
          className={`flex justify-center items-center text-font-md font-semibold wrap-break-word ${isLoading && isLoaderNeeded ? "invisible" : ""}`}
          style={{
            color:
              isDisabled && disabledTextColor
                ? disabledTextColor
                : enabledTextColor,
          }}
        >
          {btnText}
        </div>
      </div>
    </button>
  );
};

export default PrimaryLargeButton;
